import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

let searchData = {
    Name: '',
    PageNumber: 1,
    PageSize: 25
}

let user = JSON.parse(localStorage.getItem("currentUser"));
export const getFleetManagerInfo = (item) => {
    let url = `${API.FleetManager}?Name=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getFleetManagerInfoListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getFleetManagerInfoListFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getTechnicalSuperintendentsInfo = (item) => {
    let url = `${API.TechnicalSuperIntendents}?Name=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getTechSuperintendentInfoListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getTechSuperintendentInfoListFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getTechnicalExecutiveInfo = (item) => {
    let url = `${API.TechnicalExecutive}?Name=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getTechExecutiveInfoListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getTechExecutiveInfoListFailure",
                    error: "ERROR"
                })
            })
    }
}



export const getResetPassword = (mail) => {
    let url = `${API.resetpassword}?mail=${btoa(mail)}`
    return (dispatch) => {
    axios.get(url, {
        headers: {
            key: user.accessToken
        }
    })
        .then((response) => {
            dispatch({
                type: 'getResetPasswordSuccess',
                data: response.data
            })
            if (response.data) {
                toast.success('Password Reseted Successfully', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        })
        .catch((error) => {
            dispatch({
                type: 'getResetPasswordFailure',
                data: "error"
            })
        })
    }
}